(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hall-commitment"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.hallInit) return;
    slider.dataset.hallInit = '1';
    var track = slider.querySelector('.hall-slider__track');
    var slides = slider.querySelectorAll('.hall-slider__slide');
    var dotsWrap = slider.querySelector('.hall-slider__dots');
    if (!track || slides.length === 0) return;
    if (!dotsWrap || slides.length < 2) return;

    dotsWrap.innerHTML = '';
    var dots = [];
    Array.prototype.forEach.call(slides, function (slide, i) {
      var b = document.createElement('button');
      b.className = 'hall-slider__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
      dots.push(b);
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        idx = Math.max(0, Math.min(dots.length - 1, idx));
        dots.forEach(function (d, i) {
          if (i === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      });
    }, { passive: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hall-slider').forEach(initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-dog-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCdh(root) {
      if (!root || root.getAttribute('data-cdh-ready') === '1') return;
      root.setAttribute('data-cdh-ready', '1');

      var viewport = root.querySelector('[data-cdh-viewport]');
      var track = root.querySelector('[data-cdh-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cdh-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cdh-dot]'));
      var prevBtn = root.querySelector('[data-cdh-prev]');
      var nextBtn = root.querySelector('[data-cdh-next]');
      if (!viewport || !track || slides.length < 2) return;

      var index = 0;
      var total = slides.length;
      var intervalMs = parseInt(root.getAttribute('data-autoplay-ms') || '5500', 10);
      var timer = null;
      var hovering = false;
      var dragging = false;
      var startX = 0;
      var lastX = 0;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() {
        return viewport.clientWidth || root.clientWidth || 1;
      }

      function setIndex(i, immediate) {
        index = ((i % total) + total) % total;
        var x = -index * slideWidth();
        if (immediate) track.style.transition = 'none';
        else track.style.transition = '';
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
        if (immediate) {
          void track.offsetHeight;
          track.style.transition = '';
        }
        dots.forEach(function (d, di) {
          if (di === index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      function next() { setIndex(index + 1); }
      function prev() { setIndex(index - 1); }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function start() {
        stop();
        if (reduceMotion || intervalMs <= 0) return;
        timer = setInterval(function () {
          if (!hovering && !dragging && !document.hidden) next();
        }, intervalMs);
      }

      if (prevBtn) prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prev();
        start();
      });
      if (nextBtn) nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        next();
        start();
      });

      dots.forEach(function (d) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var target = parseInt(d.getAttribute('data-index'), 10);
          if (!isNaN(target)) setIndex(target);
          start();
        });
      });

      if (!root.hasAttribute('tabindex')) root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); start(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); next(); start(); }
      });

      track.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        if (e.target.closest && e.target.closest('a, button')) return;
        dragging = true;
        startX = lastX = e.clientX;
        track.style.transition = 'none';
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        lastX = e.clientX;
        var dx = lastX - startX;
        track.style.transform = 'translate3d(' + (-index * slideWidth() + dx) + 'px,0,0)';
      });
      function endDrag(e) {
        if (!dragging) return;
        var dx = lastX - startX;
        track.style.transition = '';
        if (Math.abs(dx) > slideWidth() * 0.15) {
          if (dx < 0) next(); else prev();
        } else {
          setIndex(index);
        }
        dragging = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        start();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      root.addEventListener('mouseenter', function () { hovering = true; });
      root.addEventListener('mouseleave', function () { hovering = false; });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      window.addEventListener('resize', function () { setIndex(index, true); });

      setIndex(0, true);
      start();
    }

    function bootAll() {
      document.querySelectorAll('[data-cdh-carousel]').forEach(initCdh);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e || !e.target) return;
      var root = e.target.querySelector('[data-cdh-carousel]');
      if (!root && e.target.matches && e.target.matches('[data-cdh-carousel]')) root = e.target;
      if (root) {
        root.removeAttribute('data-cdh-ready');
        initCdh(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
